import React, { createContext, useState, useEffect } from "react";
import userJSON from "./userJSON";
import sendServerLogging from "./sendServerLogging";


export const MacrosContext = createContext();

export const MacrosProvider = ({ children }) => {
  const [userMacros, setUserMacros] = useState([]);

  const fetchUserMacros = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/macros/user-macros`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: localStorage.token,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setUserMacros(data.macros || []);
        //server logging
        sendServerLogging({
          body: {
            ...userJSON(localStorage.getItem("userName")),
            event: "FETCHED_USER_MACROS",
            eventData: {},
          },
        });
      } else {
        console.error("Failed to fetch macros:", response.status);
        setUserMacros([]);
        //server logging
        sendServerLogging({
          body: {
            ...userJSON(localStorage.getItem("userName")),
            event: "ERROR_FETCH_USER_MACROS",
            eventData: { 
              error_message: `HTTP error: ${response.status}`,
              status: response.status 
            },
          },
        });
      }
    } catch (err) {
      console.error("Error fetching user's macros:", err.message);
      //server logging
      sendServerLogging({
        body: {
          ...userJSON(localStorage.getItem("userName")),
          event: "ERROR_FETCH_USER_MACROS",
          eventData: { error_message: err.message.toString() },
        },
      });
      setUserMacros([]);
    }
  };

  return (
    <MacrosContext.Provider
      value={{
        userMacros,
        setUserMacros,
        fetchUserMacros,
      }}
    >
      {children}
    </MacrosContext.Provider>
  );
};